import { createColumnHelper } from '@tanstack/react-table';
import clsx from 'clsx';
import { VacationAvatar } from '../../../components/VacationDpTable/components/VacationAvatar';
import type { PersonRow } from '../../../utils/panorama/panoramaPeopleRows';
import { STATUS_META, STATUS_ORDER } from '../vacationOverviewPage.definitions';
import { DateDisplayCell } from './vacationTableCells';

const columnHelper = createColumnHelper<PersonRow>();

const empty = <span className="text-raro-gray-400">—</span>;


export const vacationTableColumns = [
	columnHelper.accessor('name', {
		id: 'collaborator',
		header: 'Colaborador',
		size: 240,
		cell: info => {
			const row = info.row.original;
			return (
				<div className="flex items-center gap-3">
					<VacationAvatar name={row.name} photoUrl={row.photoUrl} />
					<div className="min-w-0">
						<p className="truncate font-medium text-raro-gray-900">{row.name}</p>
						{row.positionName && (
							<p className="truncate text-xs text-raro-gray-500">{row.positionName}</p>
						)}
					</div>
				</div>
			);
		},
	}),

	columnHelper.accessor(row => row.clientNames.join(', '), {
		id: 'clients',
		header: 'Clientes',
		size: 160,
		cell: info => {
			const clients = info.row.original.clientNames;
			if (clients.length === 0) return empty;
			return (
				<div className="flex flex-wrap gap-1">
					{clients.map(c => (
						<span key={c} className="inline-block rounded-full bg-raro-gray-100 px-2 py-0.5 text-xs text-raro-gray-700">
							{c}
						</span>
					))}
				</div>
			);
		},
	}),

	columnHelper.accessor('status', {
		id: 'status',
		header: 'Situação',
		size: 160,
		sortingFn: (rowA, rowB) => {
			const aIdx = STATUS_ORDER.indexOf(rowA.original.status);
			const bIdx = STATUS_ORDER.indexOf(rowB.original.status);
			return aIdx - bIdx;
		},
		cell: info => {
			const row = info.row.original;
			const meta = STATUS_META[row.status];
			return (
				<div className="flex items-center gap-2">
					<div className={clsx('h-2 w-2 rounded-full', meta.dot)} />
					<span className={clsx('inline-block rounded-full px-2 py-0.5 text-xs font-semibold', meta.badge)}>
						{meta.label}
					</span>
				</div>
			);
		},
	}),

	columnHelper.accessor(row => row.displayDates[0]?.startDate, {
		id: 'date',
		header: 'Férias / Prazo',
		size: 240,
		sortUndefined: 'last',
		cell: info => {
			const row = info.row.original;
			if (row.displayDates.length === 0) return empty;

			return (
				<DateDisplayCell displayDates={row.displayDates} status={row.status} expiredDays={row.expiredDays} />
			);
		},
	}),
];
